import Cookie from 'js-cookie'
import {TweenLite} from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

import Vue from 'vue'
import App from './App'
import router from './router/router'
import VueI18n from 'vue-i18n'
import messages from './translations'
import Analytics from 'vue-analytics'
import Meta from 'vue-meta';
import Vuex from 'vuex';

let metaLocale = document.querySelector('meta[name=language]').content;

Vue.use(VueI18n)

router.beforeEach((to, from, next) => {
    if ( to.name === 'disclaimer' ||
        (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].prerender) ||
        /bot|google|baidu|bing|msn|duckduckbot|teoma|facebookexternalhit|slurp|yandex/i
            .test(navigator.userAgent)
    ) {
        next();
        return
    }

    if (!Cookie.get('monvin-disclaimer-confirm')) {
        next({ name: 'disclaimer' })
        return
    }

    next()
})

Vue.component('scroll-indicator', require('./components/ScrollIndicator').default );

const i18n = new VueI18n({
    metaLocale,
    messages
})

router.beforeEach((to, from, next) => {
    let locale = '',
        localeUrlSegment = to.path.split('/'),
        currentLocale = i18n.locale

    // Get locale from path
    localeUrlSegment.shift()
    locale = localeUrlSegment[0]

    if( currentLocale !== locale && currentLocale !== 'en-US' ) {
        window.location.href = to.fullPath;
        return;
    }

    if( locale === '' ) {
        i18n.locale = metaLocale
        next({ name: metaLocale+'.home' })
        return
    }

    if( locale === 'disclaimer' ) {
        locale = metaLocale
    }

    // Set locale
    i18n.locale = locale
    to.params.locale = locale

    // Move on the next hook (render component view)
    next()
})

Vue.use(router)
Vue.use( Meta )
Vue.use( Vuex )
Vue.config.productionTip = false

const store = new Vuex.Store({
    state: {
        viewSteelKeg: false
    },
    mutations: {
       enableSteelKeg( state ) {
           state.viewSteelKeg = true;
       },
       disableSteelKeg( state ) {
           state.viewSteelKeg = false;
       }
    }
});
const app = new Vue({
    el: '#app',
    router,
    i18n,
    store,
    template: '<app/>',
    components: {App}
});

Vue.use( Analytics, {
    id: 'UA-86343520-30',
    router
} )

window.addEventListener('load', () => {
    if (!document.querySelector('.loc-banner')) return
    let banner = document.querySelector('.loc-banner');
    TweenLite.set(banner, {display: 'flex'});
    TweenLite.to(banner, .5, {x: '0%'})

    window.addEventListener('scroll', (e) => {
        let fadeStart = 0;
        let fadeEnd = 450;

        let el = document.scrollingElement || document.documentElement;
        let offset = el.scrollTop;

        if (offset <= fadeStart) {
            TweenLite.set(banner, {x: '0%'})
        } else if (offset >= fadeEnd) {
            TweenLite.set(banner, {x: '100%'})
        } else if (offset >= fadeStart) {
            TweenLite.set(banner, {x: (offset / fadeEnd * 100) + '%'})
        }
    })
})